import { render, staticRenderFns } from "./TradeTable.vue?vue&type=template&id=3ccb5688&"
import script from "./TradeTable.vue?vue&type=script&lang=js&"
export * from "./TradeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports